import AttachmentViewState from '../schema/AttachmentViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setIsPlaceholderAttachment')(function setIsPlacholderAttachment(
    attachment: AttachmentViewState,
    isPlaceholder: boolean
) {
    attachment.isPlaceholderAttachment = isPlaceholder;
});
